import {
  Button,
  Col,
  ConfigProvider,
  Input,
  Layout,
  message,
  Pagination,
  Popover,
  Row,
  Table,
  Tabs,
} from 'antd'
import React, { useEffect, useRef, useState } from 'react'
import OAMSider from '../oam-sider'
import { Content } from 'antd/lib/layout/layout'
import zhCN from 'antd/lib/locale/zh_CN'
import GlobalCss from '@/global.module.less'
import { sendHttpPostRequest } from '@/api/http-request'
import { BACKEND_API_URL } from '../../../constants/constants'
import PublicDatasetFormModal from './components/PublicDatasetFormModal/PublicDatasetFormModal'
import AddDatasetToTaskModal from './components/AddDatasetToTaskModal/AddDatasetToTaskModal'
import PublicTipModal from '@/pages/components/PublicTipModal/PublicTipModal'
import { useHistory, useLocation } from 'react-router-dom'
import UserCard from '../user/oam-userinfo-card'

const { Search } = Input
function OAMDatasetList() {
  const page = useRef(1)
  const pageSize = useRef(10)
  const order = useRef('')
  const orderBy = useRef('')
  const state: any = useLocation()?.state

  const queryContent = useRef('')
  const history = useHistory()

  const [activeTabkey, setActiveTabkey] = useState(
    state?.type == 'public' ? '2' : state?.type == 'task' ? '1' : '2'
  )

  const currentTabkey = useRef(state?.type == 'public' ? '2' : state?.type == 'task' ? '1' : '2') //记录当前tab

  const [addDatasetToTaskModalVis, setAddDatasetToTaskModalVis] = useState(
    false
  )
  const [deleteDatasetModalVis, setDeleteDatasetModalVis] = useState(false)
  const [datasetFormModalVis, setDatasetFormModalVis] = useState(false)
  const [formModalMode, setFormModalMode] = useState('create')

  const [publicDatasetList, setPublicDatasetList] = useState([])
  const [taskDatasetList, setTaskDatasetList] = useState([])

  const [resultSum, setResultSum] = useState(0)
  const [actionDataset, setActionDataset] = useState<any>()

  const publicCols: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: 'left',
      ellipsis: true,
    },
    {
      title: '名称',
      dataIndex: 'title',
      key: 'title',
      width: 200,
      align: 'left',
      ellipsis: true,
      render: (t, r, i) => (
        <span
          className={GlobalCss.link}
          onClick={() =>
            history.push('/oam_dataset_detail/' + r.id, { type: 'public' })
          }
        >
          {t}
        </span>
      ),
    },
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      width: 150,
      align: 'left',
      render: (text, record) => {
        return (
          <Row align="middle" wrap={false}>
            <Col flex="40px">
              <Popover
                arrowPointAtCenter={true}
                trigger="hover"
                placement="left"
                content={<UserCard user_id={record?.creator_id} />}
                title={null}
              >
                <img
                  onMouseOver={() => {}}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 15,
                    cursor: 'pointer',
                  }}
                  src={
                    record?.creator_avatar?.startsWith('http')
                      ? record?.creator_avatar
                      : BACKEND_API_URL + record?.creator_avatar
                  }
                />
              </Popover>{' '}
            </Col>
            <Col flex="auto">
              <span>{text}</span>
            </Col>
          </Row>
        )
      },
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 200,
      align: 'left',
    },
    {
      title: '操作者',
      dataIndex: 'operator_name',
      key: 'operator_name',
      width: 150,
      align: 'left',
      render: (text, record, i) => {
        if (record.operator_id > 0) {
          return (
            <Row align="middle" wrap={false}>
              <Col flex="40px">
                <Popover
                  arrowPointAtCenter={true}
                  trigger="hover"
                  placement="left"
                  content={<UserCard user_id={record?.operator_id} />}
                  title={null}
                >
                  <img
                    onMouseOver={() => {}}
                    style={{
                      width: 30,
                      height: 30,
                      borderRadius: 15,
                      cursor: 'pointer',
                    }}
                    src={
                      record?.operator_avatar?.startsWith('http')
                        ? record?.operator_avatar
                        : BACKEND_API_URL + record?.operator_avatar
                    }
                  />
                </Popover>{' '}
              </Col>
              <Col flex="auto">
                <span>{text}</span>
              </Col>
          </Row>
          )
        } else {
          return '--'
        }
      },
    },
    {
      title: '操作时间',
      dataIndex: 'update_time',
      key: 'update_time',
      width: 200,
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      fixed: 'right',
      width: 350,
      align: 'center',
      render: (t, r, i) => (
        <Row
          align="middle"
          justify="center"
          gutter={[8, 4]}
          //style={{ gap: '4px' }}
          wrap={false}
        >
          <Col style={{width:60}}>
            <Button
              //className={GlobalCss.radioBtn}
              type="dashed"
              //size='small'
              style={{borderRadius:20,fontSize:12}} 
              onClick={() =>
                history.push('/oam_dataset_detail/' + r.id, { type: 'public' })
              }
            >
              查看
            </Button>
          </Col>
          <Col style={{width:60}}>
            <Button
              onClick={() => {
                setActionDataset(r)
                setFormModalMode('edit')
                setDatasetFormModalVis(true)
              }}
              //className={GlobalCss.radioBtn}
              style={{borderRadius:20,fontSize:12}} 
              type="dashed"
              //size='small'
            >
              编辑
            </Button>
          </Col>
          <Col style={{width:70}}>
            <Button
              //className={GlobalCss.radioBtn}
              style={{borderRadius:20,fontSize:12}} 
              type="dashed"
              //size='small'
              onClick={() => {
                setActionDataset(r)
                setAddDatasetToTaskModalVis(true)
              }}
            >
              添加到
            </Button>
          </Col>
          <Col style={{width:60}}>
            <Button
              onClick={() => {
                setActionDataset(r)
                setDeleteDatasetModalVis(true)
              }}
              //className={GlobalCss.radioBtn}
              style={{borderRadius:20,fontSize:12}} 
              type="dashed"
              //size='small'
              danger
            >
              删除
            </Button>
          </Col>
        </Row>
      ),
    },
  ]

  const taskCols: any = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 80,
      align: 'left',
    },
    {
      title: '名称',
      dataIndex: 'title',
      key: 'title',
      width: 150,
      align: 'left',
      ellipsis: true,
      render: (t, r, i) => (
        <span
          className={GlobalCss.link}
          onClick={() =>
            history.push('/oam_dataset_detail/' + r.id, { type: 'task' })
          }
        >
          {t}
        </span>
      ),
    },
    {
      title: '创建者',
      dataIndex: 'creator_name',
      key: 'creator_name',
      width: 120,
      align: 'left',
      render: (text, record) => {
        return (
          <Row align="middle" wrap={false}>
            <Col flex="40px">
              <Popover
                arrowPointAtCenter={true}
                trigger="hover"
                placement="left"
                content={<UserCard user_id={record?.creator_id} />}
                title={null}
              >
                <img
                  onMouseOver={() => {}}
                  style={{
                    width: 30,
                    height: 30,
                    borderRadius: 15,
                    cursor: 'pointer',
                  }}
                  src={
                    record?.creator_avatar?.startsWith('http')
                      ? record?.creator_avatar
                      : BACKEND_API_URL + record?.creator_avatar
                  }
                />
              </Popover>{' '}
            </Col>
            <Col flex="auto">
              <span>{text}</span>
            </Col>
          </Row>
        )
      },
    },
    {
      title: '创建时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 200,
      align: 'left',
    },
    {
      title: '操作',
      dataIndex: 'action',
      key: 'action',
      width: 200,
      fixed: 'right',
      align: 'center',
      render: (t, r, i) => (
        <Row
          align="middle"
          justify="center"
          //style={{ gap: '10px' }}
          gutter={[8, 4]}
          wrap={false}
        >
          <Col>
            <Button
              className={GlobalCss.radioBtn}
              type="dashed"
              size="small"
              onClick={() =>
                history.push('/oam_dataset_detail/' + r.id, { type: 'task' })
              }
            >
              查看
            </Button>
          </Col>
        </Row>
      ),
    },
  ]

  useEffect(() => {
    queryDatasetList()
    return () => {}
  }, [activeTabkey])

  const queryDatasetList = () => {
    let data = {
      page: page.current,
      pagesize: pageSize.current,
      dataset_type: activeTabkey,
      query: queryContent.current,
      order: order.current,
      order_by: orderBy.current,
    }
    sendHttpPostRequest('dataset/api/oam_query_dataset_list/', data, (res) => {
      if (res.code == 0) {
        if (activeTabkey == '1') {
          setTaskDatasetList(res.query_list)
        } else {
          setPublicDatasetList(res.query_list)
        }
        setResultSum(res.total_sum)
      } else {
        message.error(res.message)
      }
    })
  }

  //点击了搜索按钮
  const onSearchBtn = (value: string) => {
    page.current = 1
    queryContent.current = value
    queryDatasetList()
  }

  const onPageChange = (np, nps) => {
    page.current = np
    // 请求
    queryDatasetList()
  }

  const onTabkeyChange = (key) => {
    page.current = 1
    queryContent.current = ''
    currentTabkey.current = key
    setActiveTabkey(key)
  }

  const deleteOk = () => {
    let data = {
      dataset_id: actionDataset?.id,
    }
    sendHttpPostRequest('dataset/api/oam_delete_dataset/', data, (res) => {
      if (res.code == 0) {
        message.success('删除成功~')
        queryDatasetList()
      } else {
        message.error(res.message)
      }
    })
    setDeleteDatasetModalVis(false)
  }

  const deleteCancel = () => {
    setActionDataset({})
    setDeleteDatasetModalVis(false)
  }

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <OAMSider keys={'dataset'} openKeys={[]}></OAMSider>
      <Layout style={{ backgroundColor: '#f9f9f9' }}>
        <Content
          style={{
            backgroundColor: '#fff',
            borderRadius: 5,
            minWidth: 400,
            margin: 30,
            paddingTop: 20,
          }}
        >
          <div style={{ paddingLeft: 30, paddingRight: 30 }}>
            <Tabs
              defaultActiveKey="2"
              onChange={onTabkeyChange}
              activeKey={activeTabkey}
            >
              <Tabs.TabPane tab="公共数据集" key="2">
                <Row align={'middle'} justify={'space-between'}>
                  <Col>
                    <div
                      className={'css.search1'}
                      style={{ textAlign: 'left', paddingBottom: 20 }}
                    >
                      <Search
                        placeholder="搜索数据集"
                        style={{ width: 350 }}
                        enterButton={true}
                        onSearch={onSearchBtn}
                      />
                    </div>
                  </Col>
                  {activeTabkey == '2' && (
                    <Col>
                      <Button
                        style={{ borderRadius: '15px' }}
                        type="primary"
                        onClick={() => {
                          setFormModalMode('create')
                          setDatasetFormModalVis(true)
                        }}
                      >
                        创建数据集
                      </Button>
                    </Col>
                  )}
                </Row>
                <div style={{height:500}} className={GlobalCss.tableWrapper}>
                  <ConfigProvider locale={zhCN}>
                    <Table
                      dataSource={publicDatasetList}
                      columns={publicCols}
                      // rowKey={(record) => record.id}
                      pagination={false}
                      scroll={{ x: 800 }}
                      // onChange={onTableChange}
                    />
                  </ConfigProvider>
                </div>

                <ConfigProvider locale={zhCN}>
                  <div
                    style={{
                      marginBottom: 30,
                      paddingTop: 30,
                      textAlign: 'center',
                    }}
                    className={'css.pagination'}
                  >
                    <Pagination
                      defaultCurrent={1}
                      total={resultSum}
                      defaultPageSize={20}
                      hideOnSinglePage={true}
                      onChange={onPageChange}
                      current={page.current}
                      showQuickJumper={true}
                    />
                  </div>
                </ConfigProvider>
              </Tabs.TabPane>
              <Tabs.TabPane tab="任务数据集" key="1">
                <div
                  className={'css.search1'}
                  style={{ textAlign: 'left', paddingBottom: 20 }}
                >
                  <Search
                    placeholder="搜索数据集"
                    style={{ width: 350 }}
                    enterButton={true}
                    onSearch={onSearchBtn}
                  />
                </div>
                <div style={{height:500}} className={GlobalCss.tableWrapper}>
                  <ConfigProvider locale={zhCN}>
                    <Table
                      dataSource={taskDatasetList}
                      columns={taskCols}
                      // rowKey={(record) => record.id}
                      pagination={false}
                      scroll={{ x: 800 }}
                      // onChange={onTableChange}
                    />
                  </ConfigProvider>
                </div>

                <ConfigProvider locale={zhCN}>
                  <div
                    style={{
                      marginBottom: 30,
                      paddingTop: 30,
                      textAlign: 'center',
                    }}
                    className={'css.pagination'}
                  >
                    <Pagination
                      defaultCurrent={1}
                      total={resultSum}
                      defaultPageSize={10}
                      hideOnSinglePage={true}
                      onChange={onPageChange}
                      current={page.current}
                      showQuickJumper={true}
                      pageSizeOptions={["10","20","50","100"]}
                    />
                  </div>
                </ConfigProvider>
              </Tabs.TabPane>
            </Tabs>
          </div>
        </Content>
        <PublicDatasetFormModal
          actionDataset={actionDataset}
          open={datasetFormModalVis}
          setOpen={setDatasetFormModalVis}
          mode={formModalMode}
          actionCallback={() => queryDatasetList()}
          setActionDataset={setActionDataset}
        />
        <AddDatasetToTaskModal
          open={addDatasetToTaskModalVis}
          setOpen={setAddDatasetToTaskModalVis}
          actionCallback={() => queryDatasetList()}
          actionDataset={actionDataset}
          setActionDataset={setActionDataset}
        />

        <PublicTipModal
          modalContent={
            <Row>
              <Col>
                确定要删除数据集
                <span className={GlobalCss.hlText}>{actionDataset?.title}</span>
                吗？
              </Col>
            </Row>
          }
          modalTitle={'提示'}
          handleOk={deleteOk}
          handleCancel={deleteCancel}
          open={deleteDatasetModalVis}
          setOpen={setDeleteDatasetModalVis}
        />
      </Layout>
    </Layout>
  )
}

export default OAMDatasetList
